<template>
  <div>
    <div :class="'resourceContentContainer'+(data.isFullScreen?' fullscreened':'')" ref="resourceContentContainer">
      <div class="headerContainer">
        <div class="headerText">{{$t('Resources')}}</div>
        <slot name="crossButton"></slot>
      </div>
      <div
        :class="'singleResource'+(resource.instanceData.isExpanded?' active': '')"
        v-for="(resource, index) in data.items"
        :key="index"
        @click="resourceClicked(resource)"
      >
        <div class="textOuterContainer">
          <div class="textContainer">
            <div class="titleText">
              {{ resource.instanceData.name }}
            </div>
            <div class="timeText" v-if="!data.isFullScreen">
              {{ resource.startTime }}
              <span v-if="!resource.isActive"
                >({{ resource.timeDifference }})</span
              ><span v-if="resource.isActive"
                >({{ resource.remainingTime }})</span
              >
            </div>
          </div>
          <div class="arrowContainer" v-if="!data.isFullScreen">
            <fa-icon
              :icon="['fas', 'chevron-down']"
              v-if="
                resource.instanceData.subResources != null &&
                !resource.instanceData.isExpanded
              "
            ></fa-icon>
            <fa-icon
              :icon="['fas', 'chevron-up']"
              v-if="
                resource.instanceData.subResources != null &&
                resource.instanceData.isExpanded
              "
            ></fa-icon>
          </div>
        </div>
        <div
          class="resourcesContainer"
          :style="resource.instanceData.isExpanded?'display:flex':'display:none'"
          v-if="resource.instanceData.subResources != null"
        >
          <div
            class="subResource"
            v-for="(subResource, indexx) in resource.instanceData.subResources"
            :key="indexx"
            @click="subResourceClicked(subResource, $event)"
          >
            {{ subResource.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../scss/resource-content.css";
import timeMixin from "../mixins/timeMixin";
import Vue from "vue";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.data.items.forEach((element) => {
      element.parsedStart = this.convertHoursMinsSecsToSeconds(
        element.startTime
      );
      element.parsedEnd = this.convertHoursMinsSecsToSeconds(element.endTime);
      Vue.set(element, "remainingTime", "");
      Vue.set(
        element,
        "timeDifference",
        this.convertSecondsToHourMinsSecs(
          element.parsedEnd - element.parsedStart
        )
      );
      Vue.set(element, "isActive", false);
    });
    window.addEventListener("resourceButtonEvent",this.resourceEvent)
  },
  data() {
    return {
      isLoaded: false,
      scrollSaveCount: 0,
    };
  },
  methods: {
    runFirstLoad() {},
    resourceClicked(item) {
      if (item.instanceData.subResources == null || item.instanceData.subResources.length === 0) {
        let customEvent = new CustomEvent("openLink", {
          detail: {
            routeLink: item.instanceData.link,
            alertText: item.instanceData.alertText
              ? item.instanceData.alertText
              : null,
          },
        });
        window.dispatchEvent(customEvent);
      }
      else {
        item.instanceData.isExpanded = !item.instanceData.isExpanded;
        this.$nextTick(() => {
          this.$parent.resize();
        });
      }
    },
    subResourceClicked(item, event) {
      let customEvent = new CustomEvent("openLink", {
        detail: {
          routeLink: item.link,
          alertText: item.alertText ? item.alertText : null,
        },
      });
      window.dispatchEvent(customEvent);
      event.stopPropagation();
    },
    resourceEvent(e){
      if(e.detail.state=="clicked"){
        this.scrollSaveCount = this.$parent.saveScrollState(this);
        var resourceIndex = this.data.items.findIndex(x=>x.instanceData.name==e.detail.data.name)
        this.data.items[resourceIndex].instanceData.isExpanded = true
        let resource=this.$refs.resourceContentContainer.children[resourceIndex+1]
        if(resource!=null&&!resource.classList.contains("focusBlink")){
          this.$nextTick(() => {
            resource.classList+=" focusBlink"
          });
        }
        setTimeout(() => {
          if(resource!=null)
            resource.classList.remove("focusBlink")
        }, 4000);

        if(this.initialPrefs.showDesktopOverlays){
          if(this.data.items[resourceIndex].instanceData.subResources!=null && this.data.items[resourceIndex].instanceData.subResources.length!==1){
            let customEvent = new CustomEvent("openDesktopOverlay", {
              detail: {
                component: "resourceContent",
                data: {
                  items: [this.data.items[resourceIndex]],
                  isFullScreen: true,
                },
              },
            });
            window.dispatchEvent(customEvent);
          }
          this.$root.$emit('pauseVideo')
        }
      }
    else if(e.detail.state=="hidden"){
      if(this.$parent.cancelAutoScrollState){
        this.$parent.cancelAutoScrollState(this.scrollSaveCount);
      }
    }
    },
  },
  mixins: [timeMixin]
};
</script>
